import React, {useContext, useEffect, useState} from "react";
import {Link} from "react-router-dom";

import firebase from "firebase/app";
import {UserContext} from "../../contexts/user";
import {ProfileTippy} from "../styled/Tippy";

const ProfileMenu = ({user}) => {
  const {userDispatch, logout} = useContext(UserContext);
  const [profileLinks, setProfileLinks] = useState([]);

  let unmounted = false;
  useEffect(() => {
    if (!unmounted) {
      fetchData();
    }

    return () => {
      unmounted = true;
    };
  }, []);

  const fetchData = async () => {
    const staticDataDoc = await firebase.firestore().collection("static-data").doc("profile-dropdown").get();
    if (staticDataDoc.exists) {
      const links = staticDataDoc.data().links;
      setProfileLinks(links);
    } else {
      setProfileLinks([]);
    }
  };

  return (
    <ul>
      <li>
        <a href={`https://hackernoon.com/u/${user.handle}`}>@{user.handle}</a>
      </li>

      {profileLinks.map(link => (
        <li key={link.name}>
          {link.url.includes("https") ? (
            <a href={`${link.url}`}>{link.name}</a>
          ) : (
            <Link to={`${link.url}`}>{link.name}</Link>
          )}
        </li>
      ))}
      <li>
        <button onClick={logout}>Log out</button>
      </li>
    </ul>
  );
};

const ProfileIcon = ({user}) => {
  user.avatar = user.avatar?.replace("https://hackernoon.com", "https://cdn.hackernoon.com");

  return (
    <ProfileTippy content={<ProfileMenu user={user} />} interactive={true}>
      {user.handle ? (
        <a className="profile" href="#">
          <img src={user.avatar} alt="User avatar" />
        </a>
      ) : (
        <a className="profile">
          <img src={user.avatar} alt="User avatar" />
        </a>
      )}
    </ProfileTippy>
  );
};

export default ProfileIcon;
